"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformShareLinkResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Error_1 = require("./Error");
function transformShareLinkResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { share_link } = response.response.result;
    return transformShareLinkParsedResponse(share_link);
}
exports.transformShareLinkResponse = transformShareLinkResponse;
function transformShareLinkParsedResponse(link) {
    return {
        resourceId: link.resourceid,
        clientId: link.clientid,
        resourceType: link.resource_type,
        shareLink: link.share_link,
        shareMethod: link.share_method,
    };
}
//# sourceMappingURL=ShareLink.js.map